import { render, staticRenderFns } from "./button-goto-results-v2.vue?vue&type=template&id=039a2e5a&"
import script from "./button-goto-results-v2.vue?vue&type=script&lang=ts&"
export * from "./button-goto-results-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports